export const BRINTELLIX_COPY = {
  zh: {
    loading: '加载中...',
    headerTitle: '观念分型',
    tipText: '请先回答问题来确认医生观念分型',
    startTyping: '立即进行问答',
    previewTitle: '预览',
    forwardFailed: '转发失败，请稍后重试',
    segmentTaskExecuted: '问卷任务已执行',
    segmentTaskExecutionFailed: '自动执行问卷任务失败，请稍后再试',
    segmentLabels: {
      '观望者': '观望者',
      '尝试者': '尝试者',
      '倡导者': '倡导者'
    },
    segmentDetails: {
      '观望者': [
        {
          '转化目标': '推荐伏硫西汀中标品20mg/心达悦'
        },
        {
          '主要患者场景': 'SSRI 治疗后情绪改善不佳，或明显副反应（性功能/体重）'
        },
        {
          '核心障碍': '仅关注患者情绪和躯体症状，不太关注认知症状；认为伏硫西汀和SSRI/SNRI类药物疗效上差别不大'
        },
        {
          '主要竞品': 'SSRI类（如舍曲林，帕罗西汀，西酞普兰，氟西汀，氟伏沙明）及阿戈美拉汀、托鲁地文拉法辛'
        },
        {
          '传递关键信息': [
            '伏硫西汀对情绪低落和注意力不集中有效，需要时剂量可以提高到20 毫克。',
            '对快感缺失及情感迟钝有额外获益。',
            '认知改善也很重要，独立于情绪改善'
          ]
        }
      ],
      '尝试者': [
        {
          '转化目标': '推荐伏硫西汀中标品20mg/心达悦'
        },
        {
          '主要患者场景': 'SSRI 治疗后有认知改善需求的MDD患者'
        },
        {
          '核心障碍': '关注患者认知症状的改善，但是不知道伏硫西汀在认知改善上的优势'
        },
        {
          '主要竞品': 'SSRI类（如舍曲林，帕罗西汀，西酞普兰，氟西汀，氟伏沙明）及阿戈美拉汀、托鲁地文拉法辛'
        },
        {
          '传递关键信息': [
            '伏硫西汀全面改善抑郁症状，是抑郁伴认知损害的一线推荐抗抑郁药，在需要时剂量可提高到 20 毫克，疗效最佳。',
            '功能恢复是抑郁患者的重要治疗目标'
          ]
        }
      ],
      '倡导者': [
        {
          '转化目标': [
            '倡导者：品牌保留，并与其他 HCP 分享经验；',
            '推荐心达悦/伏硫西汀中标品20mg'
          ]
        },
        {
          '主要患者场景': '高功能需求人群首选（如学生/工作人群/老年人）'
        },
        {
          '核心障碍': '认同伏硫西汀是功能需求患者的首选，但是心达悦价格高，要看患者接受度'
        },
        {
          '主要竞品': 'SSRI类（如舍曲林，帕罗西汀，西酞普兰，氟西汀，氟伏沙明）及阿戈美拉汀、托鲁地文拉法辛'
        },
        {
          '传递关键信息': [
            '心达悦在综合症状管理和安全性方面具有良好的平衡，适用于高功能需求患者的功能恢复。',
            '将心达悦扩展到需要功能或认知改善的更广泛的抑郁症患者'
          ]
        }
      ]
    }
  },
  en: {
    loading: 'Loading...',
    headerTitle: 'Segmentation',
    tipText: 'Please answer the questions first to confirm the physician segmentation.',
    startTyping: 'Start Q&A',
    previewTitle: 'Preview',
    forwardFailed: 'Forward failed. Please try again later.',
    segmentTaskExecuted: 'Questionnaire task executed.',
    segmentTaskExecutionFailed: 'Failed to execute the questionnaire task automatically. Please try again later.',
    segmentLabels: {
      '观望者': 'Observer',
      '尝试者': 'Explorer',
      '倡导者': 'Advocate'
    },
    segmentDetails: {
      '观望者': [
        {
          'Conversion Goal': 'Recommend the winning 20mg vortioxetine product / Brintellix.'
        },
        {
          'Primary Patient Scenario': 'Patients with poor mood improvement after SSRI treatment, or obvious side effects such as sexual dysfunction or weight issues.'
        },
        {
          'Core Barrier': 'Focuses only on mood and somatic symptoms, pays little attention to cognition, and believes vortioxetine has limited efficacy difference versus SSRIs or SNRIs.'
        },
        {
          'Main Competitors': 'SSRIs such as sertraline, paroxetine, citalopram, fluoxetine and fluvoxamine, plus agomelatine and desvenlafaxine.'
        },
        {
          'Key Messages': [
            'Vortioxetine improves low mood and poor concentration, and the dose can be titrated up to 20 mg when needed.',
            'It offers additional benefit for anhedonia and emotional blunting.',
            'Cognitive improvement is also important and is independent from mood improvement.'
          ]
        }
      ],
      '尝试者': [
        {
          'Conversion Goal': 'Recommend the winning 20mg vortioxetine product / Brintellix.'
        },
        {
          'Primary Patient Scenario': 'MDD patients with cognition-related improvement needs after SSRI treatment.'
        },
        {
          'Core Barrier': 'Understands the importance of cognitive improvement, but is not yet clear about vortioxetine\'s advantage in improving cognition.'
        },
        {
          'Main Competitors': 'SSRIs such as sertraline, paroxetine, citalopram, fluoxetine and fluvoxamine, plus agomelatine and desvenlafaxine.'
        },
        {
          'Key Messages': [
            'Vortioxetine delivers broad antidepressant symptom improvement and is a first-line option for depression with cognitive impairment. The dose can be increased to 20 mg when needed for optimal efficacy.',
            'Functional recovery is a critical treatment goal for patients with depression.'
          ]
        }
      ],
      '倡导者': [
        {
          'Conversion Goal': [
            'Advocate: retain brand preference and share experience with other HCPs.',
            'Recommend Brintellix / the winning 20mg vortioxetine product.'
          ]
        },
        {
          'Primary Patient Scenario': 'Preferred for patients with high functional demands, such as students, working adults and the elderly.'
        },
        {
          'Core Barrier': 'Agrees that vortioxetine is preferred for patients with functional needs, but still worries about the higher price and patient acceptance of Brintellix.'
        },
        {
          'Main Competitors': 'SSRIs such as sertraline, paroxetine, citalopram, fluoxetine and fluvoxamine, plus agomelatine and desvenlafaxine.'
        },
        {
          'Key Messages': [
            'Brintellix provides a strong balance of overall symptom management and safety, making it suitable for functional recovery in high-function-demand patients.',
            'Expand Brintellix use to a broader depression population needing functional or cognitive improvement.'
          ]
        }
      ]
    }
  }
};
